import { confirmUserBlockI18n } from './confirm-user-block';
import { filtersI18n } from './filters';
import { userFormI18n } from './user-form';

export const ruRu = ({
  ...confirmUserBlockI18n.ruRu,
  ...filtersI18n.ruRu,
  ...userFormI18n.ruRu,
}) as Record<string, unknown>;

export const en = ({
  ...confirmUserBlockI18n.en,
  ...filtersI18n.en,
  ...userFormI18n.en,
}) as Record<string, unknown>;

export const esEs = ({
  ...confirmUserBlockI18n.esEs,
  ...filtersI18n.esEs,
  ...userFormI18n.esEs,
}) as Record<string, unknown>;

export const ptBr = ({
  ...confirmUserBlockI18n.ptBr,
  ...filtersI18n.ptBr,
  ...userFormI18n.ptBr,
}) as Record<string, unknown>;
